import { useCallback } from 'react';

import { Enum, useAllEnums } from '~/data/enums';
import { PersonnelGroupValues } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmploymentDetail/useScheduleEmploymentDetail';
import { filterActiveEnums } from '~/utils/helper';

export const usePersonnelGroupOptions = () => {
  const {
    allEnums,
    isLoading: enumsLoading,
    failedToLoad: enumLoadFailed,
  } = useAllEnums();

  const getPersonnelGroupName = (number: number) => {
    const index = number - 1;
    return allEnums.PERSONNEL_GROUP_NAME[index].name;
  };

  const getPersonnelGroupOptions = useCallback(
    (groupNumber: number, personnelGroupValues?: PersonnelGroupValues) => {
      const isValidGroupNumber = groupNumber >= 1 && groupNumber <= 5;
      const isLoaded = !enumsLoading && !enumLoadFailed;
      const personnelGroupEnumValues = filterActiveEnums(
        allEnums[`PERSONNEL_GROUP_${groupNumber}`],
      );
      const personnelGroupEnumValuesLinked: Enum[] = personnelGroupValues
        ? personnelGroupEnumValues.reduce((acc, cur) => {
            const tags = cur.tags;
            if (tags) {
              let newAcc = undefined;
              tags.forEach((tag) => {
                const personnelGroup = tag.split('__')[1];
                const personnelGroupCode = tag.split('__')[2];
                if (
                  personnelGroupValues[
                    personnelGroup as keyof PersonnelGroupValues
                  ] === personnelGroupCode
                ) {
                  newAcc = [...acc, cur];
                  return;
                }
              });
              if (newAcc) {
                return newAcc;
              }
            }
            return acc;
          }, [])
        : [];
      return isValidGroupNumber && isLoaded
        ? !!personnelGroupEnumValuesLinked.length
          ? personnelGroupEnumValuesLinked
          : personnelGroupEnumValues
        : [];
    },
    [allEnums, enumsLoading, enumLoadFailed],
  );

  return {
    getPersonnelGroupOptions,
    getPersonnelGroupName,
  };
};
